
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/blockquiry/viceandvirtueindex",
      function () {
        return require("private-next-pages/about/blockquiry/viceandvirtueindex.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/blockquiry/viceandvirtueindex"])
      });
    }
  